import { Field } from 'formik';
import React from 'react';
import CustomRadio from '../../../../common/ui/CustomRadio';

const TimepickerExtraSetting = () => {
  return (
    <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pt-3 text-center">
      <div className="form-check">
        <CustomRadio label="24 hours format" isRadio={true}>
          <Field
            className="form-check-input"
            type="radio"
            name="extraFieldSetting.dateDisplayType"
            value="24_HOURS"
            id="dateDisplayType"
          />
        </CustomRadio>
        &nbsp;&nbsp;
        <CustomRadio label="12 hours format" isRadio={true}>
          <Field
            className="form-check-input"
            type="radio"
            name="extraFieldSetting.dateDisplayType"
            value="12_HOURS"
            id="dateDisplayType"
          />
        </CustomRadio>
      </div>
    </div>
  );
};

export default TimepickerExtraSetting;
